var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomerExperience = function SvgCustomerExperience(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M40 45a21.6 21.6 0 0 0-21.57 21.57V70a1 1 0 0 0 1 1h41.14a1 1 0 0 0 1-1v-3.43A21.6 21.6 0 0 0 40 45m19.57 24H20.43v-2.43a19.57 19.57 0 0 1 39.14 0ZM40 39a15 15 0 1 0-15-15 15 15 0 0 0 15 15m0-28a13 13 0 1 1-13 13 13 13 0 0 1 13-13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M40 32a8 8 0 0 0 5.66-2.34 1 1 0 1 0-1.42-1.42 6 6 0 0 1-8.48 0 1 1 0 1 0-1.42 1.42A8 8 0 0 0 40 32"
  })));
};
export default SvgCustomerExperience;